import Table from "../UserInterface/Table";
import {
  DataDendaBefore22Aug2023,
  DataDendaAfter22Aug2023,
  DataDendaSimulationExample,
  DataDendaFlexicashBefore22Aug2023,
  DataDendaC,
  DataDendaD,
  DataDendaE
} from "../../data/DataDenda";
import Description from "../UserInterface/Description";

const BulletPoint = ({ title, section }) => {
  return (
    <div style={{ maxWidth: "890px", width: "100%", alignSelf: "center" }}>
      <h3>
        <span className="bullet">{section}</span>
        {title}
      </h3>
      <style jsx>{`
        h3 {
          margin: 10px 16px;
        }
        .bullet {
          font-weight: bold;
          padding: 4px 8px;
          margin-right: 10px;
          border-radius: 16px;
          background-color: var(--color-red);
          color: var(--color-white);
        }
      `}</style>
    </div>
  );
};

const List = ({ text }) => {
  return (
    <div style={{ maxWidth: "760px", width: "100%", alignSelf: "center" }}>
      <ul>
        <li>{text}</li>
        <style jsx>{`
          ul {
            list-style-type: disc;
          }
          @media only screen and (max-width: 600px) {
            ul {
              font-size: 12px;
              margin-left: 24px;
            }
          }
        `}</style>
      </ul>
    </div>
  );
};

const DendaTableDesktop = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {/* TABLE A */}
      <BulletPoint
        section="A"
        title="Denda Keterlambatan Pembayaran Pembiayaan Barang"
      />
      <List text="Kontrak Pembiayaan Barang yang Aktif Sebelum Tanggal 22 Agustus 2023" />
      <Table
        table={DataDendaBefore22Aug2023}
        tableTitle="Denda Keterlambatan Pembayaran Pembiayaan Barang"
        width="780px"
      ></Table>
      <List text="Kontrak Pembiayaan Barang yang Aktif Sejak Tanggal 6 Februari 2024" />
      <Table
        table={DataDendaAfter22Aug2023}
        tableTitle="Denda Keterlambatan Pembayaran Pembiayaan Barang"
        width="780px"
      ></Table>
      <Description
        margin="16px"
        text="Persentase Denda Keterlambatan Pembayaran Cicilan tersebut di atas akan diperhitungkan dari jumlah yang terhutang dan telah jatuh tempo, diluar jumlah Denda Keterlambatan Pembayaran Cicilan sebelumnya (apabila ada)."
        font="Roboto"
        align="left"
        width="780px"
      ></Description>
      <Description
        margin="16px"
        text="Total jumlah Denda Keterlambatan Pembayaran Cicilan akan diakumulasi dalam hal terdapat Denda Keterlambatan Pembayaran Cicilan yang belum dibayar pada periode sebelumnya. Jika terdapat pecahan lebih kecil dari ribuan pada jumlah Denda Keterlambatan pembayaran cicilan maka kreditur dapat melakukan pembulatan ke bawah."
        font="Roboto"
        align="left"
        width="780px"
      ></Description>
      <Table
        table={DataDendaSimulationExample}
        tableTitle="Contoh Simulasi Perhitungan Denda Keterlambatan Pembayaran Pembiayaan Barang<br/>(Contoh simulasi perhitungan cicilan bulanan Rp500.000)"
        width="780px"
      ></Table>
      <Description
        margin="16px"
        text="Ketentuan pada tabel Denda Keterlambatan dan Contoh Simulasi Perhitungan Denda Keterlambatan butir A ini, sejak tanggal 7 Maret 2024 akan berlaku juga untuk Kontrak Pembiayaan barang yang Aktif Sejak tanggal 22 Agustus 2023 sampai dengan tanggal 6 Februari 2024"
        font="Roboto"
        align="left"
        width="780px"
      ></Description>
      {/* TABLE B */}
      <BulletPoint section="B" title="Denda Keterlambatan Flexicash" />
      <List text="Kontrak Flexicash yang Aktif Sebelum Tanggal 22 Agustus 2023" />
      <Table
        table={DataDendaFlexicashBefore22Aug2023}
        tableTitle="Denda Keterlambatan Pembayaran Flexicash"
        width="780px"
      ></Table>
      <List text="Kontrak Flexicash yang Aktif Sejak Tanggal 6 Februari 2024" />
      <Table
        table={DataDendaAfter22Aug2023}
        tableTitle="Denda Keterlambatan Pembayaran Flexicash"
        width="780px"
      ></Table>
      <Description
        margin="16px"
        text="Persentase Denda Keterlambatan Pembayaran Cicilan tersebut di atas akan diperhitungkan dari jumlah yang terhutang dan telah jatuh tempo, diluar jumlah Denda Keterlambatan Pembayaran Cicilan sebelumnya (apabila ada)."
        font="Roboto"
        align="left"
        width="780px"
      ></Description>
      <Description
        margin="16px"
        text="Total jumlah Denda Keterlambatan Pembayaran Cicilan akan diakumulasi dalam hal terdapat Denda Keterlambatan Pembayaran Cicilan yang belum dibayar pada periode sebelumnya. Jika terdapat pecahan lebih kecil dari ribuan pada jumlah Denda Keterlambatan pembayaran cicilan maka kreditur dapat melakukan pembulatan ke bawah."
        font="Roboto"
        align="left"
        width="780px"
      ></Description>
      <Table
        table={DataDendaSimulationExample}
        tableTitle="Contoh Simulasi Perhitungan Denda Keterlambatan Pembayaran Flexicash<br/>(Contoh simulasi perhitungan cicilan bulanan Rp500.000)"
        width="780px"
      ></Table>
      <Description
        margin="16px"
        text="Ketentuan pada tabel Denda Keterlambatan dan Contoh Simulasi Perhitungan Denda Keterlambatan butir B ini, sejak tanggal 7 Maret 2024 akan berlaku juga untuk Kontrak Pembiayaan barang yang Aktif Sejak tanggal 22 Agustus 2023 sampai dengan tanggal 6 Februari 2024"
        font="Roboto"
        align="left"
        width="780px"
      ></Description>

      {/* TABLE C */}
      <BulletPoint
        section="C"
        title="Denda Keterlambatan Home Credit Bayar Nanti"
      />
      <Table
        table={DataDendaC}
        tableTitle="Denda Keterlambatan Home Credit Bayar Nanti"
        width="780px"
      ></Table>
      <BulletPoint section="D" title="Denda Keterlambatan Modal Usaha" />
      <Table
        table={DataDendaD}
        tableTitle="Denda Keterlambatan Modal Usaha"
        width="780px"
      ></Table>
      <BulletPoint section="E" title="Denda Keterlambatan Credit Card" />
      <Table
        table={DataDendaE}
        tableTitle="Denda Keterlambatan Credit Card"
        width="780px"
      ></Table>
    </div>
  );
};

export default DendaTableDesktop;
